import { useRef, useEffect, useState } from 'react';

import { CanvasContext } from './useCanvas';
import useResponsiveSize from './useResponsiveSize';
import Wave from './wave';
import WaveMobile from './waveMobile';

const Canvas = () => {
    const canvasRef = useRef(null);
    const [isMobile, setisMobile] = useState(false)
    const { width, height } = useResponsiveSize();

    const [context, setContext] =
        useState(undefined);

    useEffect(() => {
        if (width < 806) {
            setisMobile(true)
            const ctx = canvasRef?.current?.getContext('2d');
            if (ctx) setContext(ctx);
        } else {
            const ctx = canvasRef?.current?.getContext('2d');
            if (ctx) setContext(ctx);
        }

    }, []);

    return (
        <>
            {isMobile ?
                <CanvasContext.Provider value={{ context: context }}>
                    <canvas
                        id="canvas"
                        ref={canvasRef}
                        width={width}
                        height={height}
                    ></canvas>
                    <WaveMobile />
                </CanvasContext.Provider>
                :
                <CanvasContext.Provider value={{ context: context }}>
                    <canvas
                        id="canvas"
                        ref={canvasRef}
                        width={width}
                        height={height}
                    ></canvas>
                    <Wave />
                </CanvasContext.Provider>
            }
        </>
    );
};

export default Canvas;